import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-external-privacy-form-field',
  templateUrl: './external-privacy-form-field.component.html',
  styleUrl: './external-privacy-form-field.component.scss'
})
export class ExternalPrivacyFormFieldComponent implements OnInit, OnDestroy {
  @Input('control') formControl: FormControl<boolean>;
  privacyPolicyUrl$: Observable<string>;

  constructor(private dataShareService: DataShareService) {}
  ngOnInit(): void {
    this.privacyPolicyUrl$ = this.dataShareService.tenantConfig$.pipe(
      takeUntil(this.ngUnsubscribe),
      map((tenantConfig) => tenantConfig?.common?.privacyPolicyUrl || '')
    );
  }

  private readonly ngUnsubscribe = new Subject<void>();
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
